import { render, staticRenderFns } from "./FuncionalidadeCustomizadaHistorico.vue?vue&type=template&id=2614cb8c"
import script from "./FuncionalidadeCustomizadaHistorico.vue?vue&type=script&lang=js"
export * from "./FuncionalidadeCustomizadaHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports